import { cn } from '@eliadmin/core/src/utils/style-utils';

type CreateCurriculumSubheaderProps = {
  title: string;
  className?: string;
  required?: boolean;
};

export const CreateCurriculumSubheader = ({
  title,
  className,
  required,
}: CreateCurriculumSubheaderProps) => {
  return (
    <h2
      className={cn(
        'create-curriculum-subheader flex w-full gap-[2px] text-lg font-bold md:text-2xl',
        className,
      )}
    >
      {title} {required && <span className="text-destructive">{'*'}</span>}
    </h2>
  );
};
